<template>
  <div class="home">
    <div
      @click="toAdBg(homeBg)"
      class="video"
      :style="{
        backgroundImage: homeBg.image_url
          ? 'url(' + homeBg.image_url + ')'
          : 'none',
      }"
    >
      <div class="content" @click.prevent.stop="emptyFunc">
        <div class="player">
          <!-- <router-link :to="`/liveMatchesTwo/${playing.anchorid}`" class="join_room_link">
            <div class="join_room flex-middle">进入直播间</div>
          </router-link> -->
          <div @click="enterRoom(playing)" class="join_room_link">
            <div class="join_room flex-middle">{{ $t("pc.liveIn") }}</div>
          </div>
          <LiveMatchesTwoPlayer
            v-if="isShowPlayer"
            :bulletFlag="false"
            :isHomePlay="true"
            :isEnterRoom="true"
            :detail="playing"
            ref="tcplayer"
            style="height: 100%"
          />
        </div>
        <ul class="video-list">
          <li
            v-for="video in videoList"
            :class="{ active: video.anchorid === playing.anchorid }"
            :key="video.liveid"
            @click.stop="changeVideo(video)"
          >
            <img v-lazy="video.thumb || defaultImg3" :alt="video.title" />
            <div class="video-list-mask"></div>
          </li>
        </ul>
      </div>
    </div>
    <div class="home-center">
      <!-- 正在直播 -->
      <div class="content" v-if="liveList.length">
        <div class="star-list">
          <div class="start-title-content">
            <div class="live-item-title">
              <img :src="require('@/assets/home/hotLive.png')" />
              <div class="title-content">{{ $t("pc.hotLiving") }}</div>
            </div>
            <router-link
              :to="{ name: 'liveMatches' }"
              exact-active-class="active"
            >
              <div
                class="more hot-live"
                @mouseover="allliveact = 0"
                @mouseout="allliveact = null"
              >
                {{ $t("pc.allLiving") }}
                <!-- <img
                  :src="
                    allliveact == 0
                      ? require('../../assets/img/home/Vector1.png')
                      : require('../../assets/img/home/Vector1.png')
                  "
                  style="width: 8px; height: 14px"
                /> -->
              </div>
            </router-link>
          </div>
          <div class="live-list live-match">
            <div
              class="live el-col el-col-4"
              style="padding-left: 8px; padding-right: 8px"
              v-for="(live, index) in liveList"
              :key="index"
            >
              <LiveItemHot type="live" :live="live" />
            </div>
          </div>
        </div>
      </div>

      <!-- 体育赛事直播 -->
      <div class="content">
        <div class="start-title-content liveroom-title flex-between">
          <div class="live-item-title">
            <img :src="require('@/assets/home/sportMatch.png')" />
            <div class="title-content">{{ $t("pc.sportLiving") }}</div>
            <div
              class="game-btn"
              v-for="item in ballName"
              :key="item.id"
              :class="{ matchType: true, selectedType: ballId === item.id }"
              @click="toggleMatch(item.id)"
            >
              {{ $t(item.name) }}
            </div>
          </div>

          <!-- <router-link
            :to="{ name: 'schedule' }"
            exact-active-class="active"
            class="flex-middle-only"
          >
            <div
              class="more hot-live"
              @mouseover="allliveact = 1"
              @mouseout="allliveact = null"
            >
              {{ $t("pc.allMatch") }}
              <img
                :src="
                  allliveact == 1
                    ? require('../../assets/img/home/Vector.png')
                    : require('../../assets/img/home/Vector1.png')
                "
                style="width: 8px; height: 14px"
              />
            </div>
          </router-link> -->
        </div>

        <!-- 日期选择v-if="Object.keys(filterDates).length > 0" -->
        <div
          class="match-swiper flex-middle"
          v-if="Object.keys(filterDates).length > 0"
        >
          <!--
        <el-button class="swiper-button-prev" @click.stop="changeDate('prev')" :disabled="disabledArrowBtn.prev"></el-button>
        -->
          <div class="swiper-match-date flex-middle-only">
            <div class="flex-row date-panel-l" :style="{ left: leftP + 'rem' }">
              <div
                class="swiper-slide"
                :id="`date-${key}`"
                v-for="(item, key) in filterDates"
                :key="key"
              >
                <div
                  class="date-item"
                  :class="{ select: selectedDate.ymd === item.ymd }"
                  @click="changeDate(item)"
                  @mouseover="changeMouseover(item.addDayCount)"
                  @mouseout="changeMouseout(item.addDayCount)"
                >
                  <!-- <div class="date-item-t">{{ item.ymd === yestoday ? '赛果' : item.week2 }}</div> -->
                  <div class="date-time-line">
                    <div class="date-line"></div>
                    <img
                      :src="
                        item.addDayCount === selectedDate.addDayCount
                          ? require('@/assets/home/pingActive.png')
                          : item.ymd === yestoday
                          ? require('@/assets/home/ping.png')
                          : item.addDayCount === hoverIndex
                          ? require('@/assets/home/pingActive.png')
                          : require('@/assets/home/ping.png')
                      "
                      alt=""
                    />
                    <div class="date-line"></div>
                  </div>
                  <div class="date-item-t">
                    {{
                      item.ymd === today
                        ? $t("match.today")
                        : item.ymd === yestoday
                        ? $t("match.result")
                        : item.ymd === tomorroy
                        ? $t("pc.tomorrow")
                        : item.week2
                    }}
                  </div>
                  <!-- <div class="date-item-t">{{ item.ymd === tomorroy ? '明日' : item.week2 }}</div> -->
                  <div class="date-item-b">
                    <div v-if="selectedDate.ymd === item.ymd">
                      {{ $t("pc.matchNum", { num: numtotal }) }}
                    </div>
                    <div v-else>{{ item.md }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!--
        <el-button class="swiper-button-next" @click.stop="changeDate('next')" :disabled="disabledArrowBtn.next"></el-button>
				-->
        </div>

        <match-recommend
          v-if="isRecommendMatchLoad"
          :pendingMatch="pendingMatch"
          :staringMatch="staringMatch"
          :finishedMatch="finishedMatch"
          :soondMatch="soondMatch"
          :key="selectedDate.ymd"
        ></match-recommend>
      </div>

      <!-- <div class="content match-starting">
        <div class="swiper-container swiper-match">
          <div class="swiper-wrapper">
            <div class="swiper-slide" v-for="item in hotMatch" :key="item.id">
              <LiveItemS :hot-match-item="item" />
            </div>
          </div>
        </div>
        <div class="match-starting-more" @click="toSchedule">
          <img src="../../assets/img/home/home_schedule.png" />
          <div>全部赛程</div>
        </div>
        <div class="swiper-button swiper-button-prev"></div>
        <div class="swiper-button swiper-button-next"></div>
      </div> -->
      <!-- 新闻头条 -->
      <!-- <div class="news-notice">
        <div class="news-box left">
          <div class="up">
            <img src="./home_hot.png" />
            <div class="">新闻头条</div>
          </div>
          <div class="down">
            <SwiperNewsHome />
          </div>
        </div>
        <div class="news-box mid">
          <div class="up"></div>
          <div class="down">
            <router-link to="/news" target="_blank">
              <img class="news-more" src="./home_news_more.png" alt="" />
            </router-link>
            <router-link :to="`/news_detail/${item.id}`" target="_blank" class="down-up" v-for="(item, index) in newsListUp" :key="index">
              <div class="down-up-title">
                <div class="hot"><img src="./hot.png" alt="" /></div>
                <div class="down-up-title-content">{{ item.title }}</div>
              </div>
              <div class="down-up-desc">{{ item.profile }}</div>
            </router-link>
            <div class="down-down">
              <router-link :to="`/news_detail/${item.id}`" target="_blank" class="down-down-title" v-for="(item, index) in newsListDown" :key="index">
                [新闻] {{ item.title }}
              </router-link>
            </div>
          </div>
        </div>
        <div class="news-box right">
          <div class="up">
            <img src="./home_msg.png" />
            <div class="">最新消息</div>
          </div>
          <div class="right-down">
            <div class="right-swiper">
              <SwiperNewsHomeSmall />
            </div>
            <div class="right-notice">
              <router-link :to="`/notice/${item.id}`" target="_blank" class="notice-list" v-for="(item, index) in noticeList" :key="index">
                <div class="notice-list-dot"></div>
                <div class="notice-list-title">
                  {{ item.title }}
                </div>
                <div class="notice-list-time">{{ item.create_time }}</div>
              </router-link>
            </div>
          </div>
        </div>
      </div> -->
      <!-- 明星大神 -->
      <!-- <div class="hot-live-home">
        <SwiperHotLiveHome :anchors="videoList" />
      </div> -->

      <!-- 官方活动 -->
      <!-- <div class="content">
        <el-row :gutter="0">
          <el-col :span="24">
            <div class="start-title-content">
              <div class="live-item-title">
                <img src="./home_activity.png" />
                <div class="title-content">官方活动</div>
              </div>
            </div>
            <div class="swiper-activity">
              <router-link
                :to="`/activity_details/${item.id}`"
                target="_blank"
                class="activity-item"
                v-for="item in activityBannerList"
                :key="item.id"
                @click="toAct(item)"
              >
                <img class="activity-item-img" :src="item.thumb_url ? item.thumb_url : require('./default_pic.png')" />
              </router-link>
            </div>
          </el-col>
        </el-row>
      </div> -->
      <img src="./one.png" alt="" class="one" />
      <img src="./two.png" alt="" class="two" />
      <img src="./three.png" alt="" class="three" />
    </div>
    <Footer />
    <!-- <div class="float-right">
      <div class="checkin-btn" v-show="isCheckinBtnShow">
        <img
          @click="openCheckin"
          class="a"
          src="@/assets/img/checkin/checkin.png"
          alt=""
        />
        <img
          @click="isCheckinBtnShow = false"
          class="b"
          src="@/assets/img/checkin/close.png"
          alt=""
        />
      </div>
    </div> -->
  </div>
</template>

<script>
import Swiper, { Autoplay, Navigation } from "swiper";
Swiper.use([Autoplay, Navigation]);
import LiveItemS from "@/components/live-item/live-item-s";
import LiveItemHot from "@/components/live-item/live-item-hot";
import LiveMatchesTwoPlayer from "@/components/player/liveMatchesTwoPlayer";
import MatchRecommend from "@/components/match-recommend/match-recommend";
import SwiperNewsHome from "@/components/swiper/swiper-news-home";
import SwiperNewsHomeSmall from "@/components/swiper/swiper-news-home-small";
import { mapMutations, mapState } from "vuex";
import { post } from "../../util/http";
import { dayCount, format } from "@/util/time";
import moment from "moment";
import SwiperHotLiveHome from "../../components/swiper/swiper-hot-live-home.vue";
import Footer from "@/components/footer/footer";
import { enterRoom } from "@/util/enterRoomTicket";

const titleObj = {
  onv2: "Xôi Lạc TV - Trực Tiếp Bóng Đá Hôm Nay | Xem Bóng Đá Miễn Phí",
  "8on": "8ON LIVE TRỰC TIẾP BÓNG ĐÁ HD - XEM BÓNG MIỄN PHÍ ",
  sport247: "SPORT247.VN TRỰC TIẾP BÓNG ĐÁ HD - XEM BÓNG MIỄN PHÍ ",
};
const descriptionObj = {
  onv2: "Xoilac TV - Cập nhật link xem trực tiếp bóng đá hôm nay, truc tiep bong da, xem bong da truc tuyen miễn phí chất lượng cao. Cùng Xoi Lac TV theo dõi mọi trận cầu đỉnh cao!",
  "8on":
    "8ON LIVE - Cập nhật link xem trực tiếp bóng đá trưc tuyến miễn phí HD  rõ nét.  Cùng 8ON LIVE theo dõi mọi trận cầu đỉnh cao!",
  sport247:
    "SPORT247 - Cập nhật liên tục các đường link xem trực tiếp bóng đá HD miễn phí, đảm bảo chất lượng hình ảnh rõ nét. Hãy cùng SPORT247 đón xem những trận cầu đỉnh cao!",
};
const keywordsObj = {
  onv2: "xoilac, xoilac tv, xôi lạc trực tiếp bóng đá hôm nay, truc tiep bong da, xem bong da truc tuyen",
  "8on":
    "8on. 8on.com -8on live trực tiếp bóng đá hôm nay,trực tiếp bóng đá,xem bóng miễn phí",
  sport247:
    "SPORT247 - SPORT247.VN trực tiếp bóng đá hôm nay,trực tiếp bóng đá,xem bóng miễn phí",
};

export default {
  metaInfo() {
    return {
      title: titleObj[SITE],
      meta: [
        {
          name: "description",
          content: descriptionObj[SITE],
        },
        {
          name: "keywords",
          content: keywordsObj[SITE],
        },
      ],
    };
  },
  components: {
    LiveItemS,
    LiveItemHot,
    LiveMatchesTwoPlayer,
    MatchRecommend,
    SwiperNewsHome,
    SwiperNewsHomeSmall,
    SwiperHotLiveHome,
    Footer,
  },
  data() {
    const { s = 1, d = 0, c = 777, i = 0, l = "" } = this.$route.query;
    // const {s = 1, d = 0, c = 777, i = 0, l = '' } = {
    //   s:1,
    //   d:0,
    //   c:777,
    //   i:0,
    //   l:''
    // }

    const selectedDate = dayCount(Number(d));

    const selectedLeagues = {};

    l?.split(",").forEach((league_name) => {
      selectedLeagues[league_name] = {
        comp: league_name,
      };
    });
    console.log(selectedLeagues);
    return {
      // homeBg: { image_url: require("./bg-home-banner.png") },
      homeBg: {},
      videoList: [],
      liveList: [],
      activityBannerList: [],
      newsSwipers: "",
      newsListUp: [],
      newsListDown: [],
      newsListRight: [],
      // hotMatchList: [],
      playing: {},
      full: false,
      paused: false,
      mute: false,
      volume: 100,
      tepVolume: 100,
      currentUrl: "",
      limitPosition: 500,
      scrolled: false,
      lastPosition: 0,
      hotMatch: [],
      ballName: [
        { name: "common.hot", id: 0 },
        { name: "match.football", id: 1 },
        { name: "match.basketball", id: 2 },
        // { name: "网球", id: 4 }
      ],
      ballId: 0,
      pendingMatch: [], // 赛事推荐 未开始的比赛
      staringMatch: [], // 赛事推荐 正在进行的比赛
      finishedMatch: [], //已结束的比赛
      soondMatch: [], //赛事推荐 马上开始的比赛
      numtotal: 0,
      isRecommendMatchLoad: false,
      isShowPicture: false,
      setRecMatch: [],
      setMatch: [],
      moment: moment,
      inprogress: [],
      hasnotstarted: [],
      notStarted: [],
      qualityName: [
        { name: "原画1080P", id: 1 },
        { name: "蓝光4M", id: 2 },
        { name: "超清", id: 3 },
        { name: "高清", id: 4 },
        { name: "流畅", id: 5 },
      ],
      qualityId: 1,
      qualityItemName: "原画1080P",
      selectType: 0,
      noticeList: [],
      isShowPlayer: true,

      category: Number(c),
      selectedDate,
      selectedLeagues: selectedLeagues,
      isLive: Number(i),
      page: 1,
      sportId: Number(s),

      hoverIndex: null,
      allliveact: null,
      leftP: 0,
      isCheckinBtnShow: true,
    };
  },
  computed: {
    ...mapState(["userInfo", "appConfig", "wrapHeight"]),
    defaultImg() {
      return require("./logoe1.png");
    },
    defaultImg2() {
      return require("./logoe2.png");
    },
    defaultImg3() {
      return require("./hear-not.png");
    },
    playIcon() {
      if (!this.paused) return require("./stop@2x.png");
      return require("./play@2x.png");
    },
    volumeIcon() {
      if (this.mute && this.volume === 0) return require("./mute.png");
      return require("./volume.png");
    },

    // 首页日期
    selectedLeagueMatches() {
      console.log(this.selectedLeagues);
      return Object.values(this.selectedLeagues).length;
    },

    filterDates() {
      let filterDates = {};
      let range = [-7, 7];
      // 比赛状态, 0-所有(默认), 1-仅进行中的赛事,3-仅完场的赛事(赛果),赛程 666, 热门 777,赛事搜索888, 收藏999
      // console.log("this.category: ",this.category);
      switch (this.category) {
        case 0:
          range = [];
          break;
        case 3:
          range = [-6, 0];
          break;
        case 666:
          range = [0, 6];
          break;
        case 999:
          range = [];
          break;
        default:
          range = [-1, 6];
      }
      if (range.length === 0) return {};
      for (let i = range[0]; i <= range[1]; i++) {
        const dateInfo = dayCount(i);

        filterDates[dateInfo.ymd] = {
          ...dateInfo,
          counts: "...",
        };
      }

      return { ...filterDates };
    },

    disabledArrowBtn() {
      const arr = Object.values(this.filterDates) || [];
      const first = arr[0] || {};
      const last = arr[arr.length - 1] || {};
      if (this.selectedDate.ymd === first.ymd) {
        return { prev: true, next: false };
      } else if (this.selectedDate.ymd === last.ymd) {
        return { prev: false, next: true };
      }
      return { prev: false, next: false };
    },

    getUserFavoriteMatches() {
      const userInfo = JSON.parse(localStorage.getItem("userInfo") || "{}");
      if (!userInfo.token) return;

      post({
        url: "/api/match/countUserFavorite",
        data: { sport_id: this.sportId },
      }).then((res) => {
        if (res.status === 200 && res.data?.status === 0) {
          this.favoriteMatches = res.data?.data?.quantity || 0;
        }
      });
    },
  },
  beforeDestroy() {
    if (this.player) this.player.destroy();
    if (this.timer) clearTimeout(this.timer);
  },
  destroyed() {
    clearTimeout(this.pollingST);
    clearTimeout(this.hotMatchTime);
    clearTimeout(this.recommendMatchTime);
    this.toggleHomePage(false);
  },
  watch: {
    volume(newVal) {
      if (this.timer) clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.player.volume(newVal / 100);
      }, 200);
    },
    "userInfo.id": {
      handler(n, o) {
        this.$store.dispatch("checkAnchorStatus");
      },
    },
    hotMatch() {
      this.$nextTick(() => {
        new Swiper(".swiper-match", {
          // observer: true,
          // observeParents: true,
          speed: 1000,
          loop: false,
          slidesPerView: 4,
          spaceBetween: 16,
          autoplay: {
            delay: 5000, //自动切换的时间间隔，单位ms
            stopOnLastSlide: false, //如果设置为true，当切换到最后一个slide时停止自动切换。
            disableOnInteraction: false, //用户操作swiper之后，是否禁止autoplay。
            reverseDirection: false, //开启反向自动轮播。
            waitForTransition: false, //等待过渡完毕。自动切换会在slide过渡完毕后才开始计时。
          },
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          },
        });
      });
    },
    $route(to, from) {
      console.log("$route to==>", to.path);
      this.pathname = to.path;
      if (to.path == "/home") {
        //   this.$nextTick(() => {
        //   this.$refs.contentData.scrollTop = 0
        // })
        // window.scrollTo(0, 0)
      }
      console.log("$route from==>", from.path);
    },
  },
  created() {
    this.yestoday = dayCount(-1).ymd;
    this.today = dayCount(0).ymd;
    this.tomorroy = dayCount(1).ymd;
  },
  mounted() {
    // this.$store.commit("changeWrapHeight", "height: 100%");
    // console.log(this.wrapHeight);
    console.log(
      'moment().format("YYYY-MM-DD ")',
      moment(1535419062000).format("YYYY-MM-DD ")
    );
    this.toggleHomePage(true);

    this.getHomeBanner(); //动态banner
    this.getVideoList();
    // this.getLiveList();
    this.getNewsList();
    this.getRecommendMatch(this.ballId);
    this.getActivityBannerList();
    this.getNoticeList();

    // 联赛列表
    // this.getMatch();
    setTimeout(() => {
      this.scrollToDateItem(this.selectedDate);
    }, 50);
    if (!this.videoList.length) return;
    // this.playing = this.videoList[0] || {};
    // if (document.getElementById("live_player")) {
    //   // this.createPlayer();
    // }
    // this.getBasket();
    // if (!process.server) {
    //   this.polling(this.ballId);
    // }
    //console.log("this.entertainmentList ",this.entertainmentList);
  },
  methods: {
    ...mapMutations([
      "changeOwnLive",
      "toggleLogin",
      "toggleHomePage",
      "changeWrapHeight",
      "toggleCheckinDialog",
    ]),
    enterRoom,
    openCheckin() {
      // this.toggleCheckinDialog(true);
    },
    async getHomeBanner() {
      const {
        data: { data },
      } = await post({
        url: "/api/ads/getAds",
        data: {
          equipment: 1,
          category: 6,
        },
      });
      if (data) {
        this.homeBg = data[0];
      }
    },
    toAdBg({ jump_url = "", jump_type = 2 }) {
      let url = jump_url || "";
      let v =
        /^(https?:\/\/)([0-9a-z.]+)(:[0-9]+)?([/0-9a-z.]+)?(\?[0-9a-z&=]+)?(#[0-9-a-z]+)?/gim;
      if (v.exec(url) && jump_type == 2) {
        window.open(url);
      } else if (url && jump_type == 1) {
        this.$router.push(url);
      }
    },

    async getVideoList() {
      const {
        data: { data },
      } = await post({
        url: "/api/live/getLiveList",
        data: {
          uid: this.userInfo.id || 0,
        },
      });
      this.videoList = data.slice(0, 5) || [];
      this.liveList = data.slice(0, 12) || [];
      this.playing = this.videoList[0] || {};
    },

    async getNewsList() {
      const {
        data: { data },
      } = await post({
        url: "/api/news/getNewsList",
        data: {
          news_category_id: 1,
          page: 1,
          size: 13,
        },
      });
      this.newsListUp = data.slice(0, 3);
      this.newsListDown = data.slice(3, 7);
      this.newsListRight = data.slice(7, 13);
    },

    async getActivityBannerList() {
      // const {
      //   data: { data },
      // } = await post({ url: "/api/ads/getHomeBottomOfficialAd" });
      // this.activityBannerList = data || [];
      // if (this.activityBannerList.length > 4) {
      //   this.activityBannerList = this.activityBannerList.slice(0, 4);
      // }
      const {
        data: { data },
      } = await post({
        url: "/api/activity/getActivityProfileList",
        data: {
          page: 1,
          size: 20,
        },
      });
      this.activityBannerList = data.OngoingActivityList || [];
      if (this.activityBannerList.length > 4) {
        this.activityBannerList = this.activityBannerList.slice(0, 5);
      }
    },
    // async getHotMatchList() {
    //   const {
    //     data: { data },
    //   } = await post({ url: "/webapi/home/getNewHomeData" });
    //   // console.log("data===>: ",data);
    //   this.hotMatchList = data.sport_lives || [];
    //   if (this.hotMatchList.length > 8) {
    //     this.hotMatchList = this.hotMatchList.slice(0, 8);
    //   }
    // },
    changeQuality(item) {
      this.qualityId = item.id;
      this.qualityItemName = item.name;
    },
    getHotMatch() {
      post({
        // 老接口
        url: "/api/match/getHotMatchCards4Crawler",
        // url: "/api/match/getRecommendMatches4Crawler",
      }).then(({ data }) => {
        this.hotMatch = data.data;
        // this.hotMatchTime = setTimeout(() => {
        //   clearTimeout(this.hotMatchTime);
        //   this.getHotMatch();
        // }, 60000);
      });
    },
    prevMatch(index) {
      this.mySwiper.slidePrev();
    },
    nextMatch(index) {
      this.mySwiper.slideNext();
    },
    toSchedule() {
      this.$router.push("/schedule");
    },
    changeSlider() {
      // 改变音量大小
      this.player.volume(this.volume / 100);
      if (this.volume == 0) {
        this.mute = true;
      }
      this.tepVolume = this.volume;
    },
    fullScreen() {
      console.log("全屏");
      this.player.fullScreen.request("browser");
    },
    goPath() {
      if (!this.userInfo.id) {
        return this.toggleLogin();
      } else {
        this.$router.push({
          path: `/user-center/scheduleMatch`,
        });
      }
    },
    onlive(item) {
      post({
        url: "/api/sport/getPullUrl ",
        data: {
          match_id: item.id,
          request_time: item.time,
          type: item.sport_type,
        },
      }).then(({ data }) => {
        this.$router.push({
          name: "liveplay",
          params: { playUrl: data.data.pushurl1 },
        });
      });
    },
    setStatus(status) {
      let pictorial;
      switch (status) {
        case 0:
          pictorial = "比赛异常";
          break;
        case 1:
          pictorial = "未开赛";
          break;
        case 2:
          pictorial = "上半场";
          break;
        case 3:
          pictorial = "中场";
          break;
        case 4:
          pictorial = "下半场";
          break;
        case 5:
          pictorial = "加时赛";
          break;
        case 7:
          pictorial = "点球决战";
          break;
        case 8:
          pictorial = "完场";
          break;
        case 9:
          pictorial = "推迟";
          break;
        case 10:
          pictorial = "中断";
          break;
        case 11:
          pictorial = "腰斩";
          break;
        case 12:
          pictorial = "取消";
          break;
        default:
          pictorial = "待定";
      }
      return pictorial;
    },
    getBasket() {
      // 推荐赛事
      post({
        url: "/api/sport/getRecMatch",
        data: {
          date: moment().format("YYYY-MM-DD "),
        },
      }).then(({ data: data }) => {
        this.setMatch = data.data.matchs.slice(0, 5);
      });
    },
    // createPlayer() {
    //   if (!this.playing.pull_url) return;
    //   this.player = new this.$DPlayer({
    //     container: document.getElementById("live_player"),
    //     autoplay: true,
    //     preload: "auto",
    //     loop: true,
    //     hotkey: false,
    //     volume: 0.5,
    //     video: {
    //       url: this.playing.pull_url,
    //       // pic: this.playing.thumb,
    //       type: this.filterType(this.playing.pull_url),
    //       // type: "auto"
    //     },
    //   });
    //   this.player.on("pause", () => {
    //     this.paused = true;
    //   });

    //   this.player.on("play", () => {
    //     this.paused = false;
    //   });

    //   this.player.volume(1, true, false);
    //   this.volume = 100;

    //   this.player.on("canplay", () => {
    //     this.player.video.play().catch(() => {
    //       this.volume = 0;
    //       this.player.video.muted = true;
    //       this.player.play();
    //       this.player.volume(0, true, false);
    //     });
    //   });
    // },
    filterType(fileName) {
      let fileExtension = fileName.split(".").pop().toLowerCase();
      if (fileExtension === "flv") {
        return "flv";
      } else if (fileExtension === "mp4") {
        return "auto";
      } else {
        return "hls";
      }
    },
    getFootball(params) {
      // 足球
      return new Promise((resolve, reject) => {
        post({
          url: this.urlParams(params),
        }).then(({ data }) => {
          resolve(data);
        });
      });
    },
    polling(params) {
      this.getFootball(params).then((data) => {
        // 0:异常 1:進行中比賽 2:未開始 8:完賽
        this.inprogress = data.data.matchs.filter(
          (item) => item.in_progress === 1
        );
        this.hasnotstarted = data.data.matchs.filter(
          (item) => item.in_progress === 0
        );
        this.notStarted = data.data.matchs.filter(
          (item) => item.in_progress === 2
        );
        this.pollingST = setTimeout(() => {
          clearTimeout(this.pollingST);
          this.polling(this.ballId);
        }, 100000);
      });
    },
    urlParams(params) {
      // 接口调用方法
      if (params === 2) {
        return "/api/football/getDateMatch";
      } else if (params === 3) {
        return "/api/basket/getDateMatch";
      } else if (params === 4) {
        return "/api/tennis/getDateMatch";
      } else {
        return "/api/sport/getDateMatch";
      }
    },
    changeVideo(video) {
      // if (video.liveid === this.playing.liveid) return;

      this.playing = video || {};
      // this.isShowPlayer = false;
      // this.$nextTick(() => {
      //   this.isShowPlayer = true;
      //   this.playing = video || {};
      // });
    },
    pause() {
      if (!this.paused) {
        this.player.pause();
      } else {
        this.player.play();
      }
      this.paused = !this.paused;
    },
    toggleVol() {
      this.player?.volume(!this.mute ? 0 : this.tepVolume / 100);
      this.volume = !this.mute ? 0 : this.tepVolume;
      this.mute = !this.mute;
    },
    toggleMatch(id) {
      this.ballId = id;
      this.getRecommendMatch(id);
    },
    getRecommendMatch(id) {
      post({
        url: "/api/match/getRecommendMatches4Crawler",
        data: {
          sport_id: id,
          date: moment(this.selectedDate.ymd).valueOf(),
        },
      }).then(({ data }) => {
        this.pendingMatch = data.data.pending || [];
        this.staringMatch = data.data.staring || [];
        this.soondMatch = data.data.soon || [];
        this.finishedMatch = data.data.finished || [];
        this.numtotal = data.data.total || 0;
        console.log(this.pendingMatch);
        this.isRecommendMatchLoad = true;
      });
    },

    toAct(item = {}) {
      console.log("toAct: ", item);
      if (item && item.hasOwnProperty("jump_url")) {
        let { jump_type = 0 } = item;
        if (jump_type == 1) {
          this.$router.push({
            path: item.jump_url,
          });
          return;
        }
        if (jump_type == 2) {
          window.open(item.jump_url, "_blank");
          return;
        }

        //this.$router.push({
        // path: `/live/${this.playing.anchorid}`
        //path: `/liveMatchesTwo/${this.playing.anchorid}`
        //});
      }
    },
    getNoticeList() {
      post({
        url: "/api/announcement/getAnnouncementList",
        data: {
          page: 1,
          size: 20,
        },
      })
        .then(({ data: { data = [] } }) => {
          data.forEach((v) => {
            // v.dateObj = dayCount(0, v.update_time);
            v.create_time = format(v.create_time * 1000, "MM-dd");
          });
          this.noticeList = data;
        })
        .catch((err) => {
          console.log("err: ", err);
        });
    },
    toNotice({ id = "" }) {
      if (!id) {
        return;
      }
      this.$router.push({
        path: `/notice/${id}`,
      });
    },

    emptyFunc($e) {},

    // 获取赛事列表
    getMatch() {
      // this.selectedLeagues= {
      //   "":{
      //     comp:''
      //   }
      // }
      console.log(this.selectedLeagues, this.sportId);
      const league_names = Object.keys(this.selectedLeagues).filter((v) => !!v);
      const params = {
        comps: league_names, // 联赛名称
        is_live: this.isLive, // 是否直播中 0 未直播 1 直播中
        date: this.selectedDate.ymd, // 是否直播中 0 未直播 1 直播中
        match_status: this.category, // 比赛状态,0-所有(默认),1-仅进行中的赛事,3-仅完场的赛事(赛果),赛程 666, 热门 777,赛事搜索888, 收藏999
        match_name: "",
        page: this.page,
        size: 10,
        // sport_id: 1,               // 0全部 1足球 2篮球
        sport_id: this.sportId, // 0全部 1足球 2篮球
        terminal: 3, // 0app 3 pc
      };
      this.resetUrlSearchQuery();

      this.loading = true;
      this.loaded = false;
      post({ url: "/api/match/getMatchList", data: params })
        .then((res) => {
          this.loading = false;
          this.loaded = true;
          this.showPopover = false;

          if (res.status === 200 && res.data.status === 0) {
            const result = res.data || {};

            this.matches = result.data?.matchList || [];
            this.totalCount = result.data?.count;
            console.log(result.data, this.filterDates, this.selectedDate.ymd);
            if (this.filterDates[this.selectedDate.ymd]) {
              this.filterDates[this.selectedDate.ymd].counts =
                result.data?.count;
              console.log();
            }
          }
        })
        .catch(() => {
          this.loaded = true;
          this.loading = false;
          this.showPopover = false;
        });
    },

    // 切换日期
    changeDate(item = {}) {
      this.page = 1;
      this.isLive = 0;

      // 重置选中的联赛
      this.selectedLeagues = {};

      this.scrollToDateItem(item);

      // 刷新联赛列表
      // this.getLeagues();

      // this.getMatch();
      this.getRecommendMatch(this.ballId);
    },

    //hover日期
    changeHover(index) {
      this.hoverIndex = index;
    },

    changeMouseover(index) {
      this.hoverIndex = index;
    },
    changeMouseout() {
      this.hoverIndex = null;
    },

    // 滚动到指定的 日期
    scrollToDateItem(flag = "next", behavior = "smooth") {
      // 当前位置
      let current = this.selectedDate.addDayCount;
      const dates = Object.values(this.filterDates);
      if (flag === "next") {
        current = Math.min(current + 1, dates[dates.length - 1].addDayCount);
      } else if (flag === "prev") {
        current = Math.max(current - 1, dates[0].addDayCount);
      } else {
        current = flag.addDayCount;
      }
      this.selectedDate = dayCount(current);
      return;
      console.log("this.selectedDate: ", this.selectedDate, current);
      let leftP = 0;
      let pos = current > 0 ? true : false;
      /*
			if(current == 0){
				// leftP = -(Math.abs(current/7) * 1.88 * 7);
				leftP = -(1.88 * 7);
			}else if(current < 0){
				// leftP = -(Math.abs(current/7) * 1.88 * 7);
				leftP = 0;
			} else if(current > 0){
				leftP = -(1.88 * (7+1));
			}
			*/
      if (current > -6 && current < 3) {
        // leftP = -(Math.abs(current/7) * 1.88 * 7);
        leftP = (current + 6) * -1.88;
      } else if (current > 2 && current < 8) {
        leftP = (2 + 6) * -1.88;
      }

      setTimeout(() => {
        this.leftP = leftP;
        // const scrollToEle = document.getElementById(`date-${this.selectedDate.ymd}`)
        // console.log("scrollToEle: ",scrollToEle)
        // scrollToEle?.scrollIntoView({behavior, block: "center", inline: "start"})
      }, 50);
    },

    resetUrlSearchQuery() {
      const origin = window.location.origin;
      const path = window.location.pathname;
      const league_names = Object.keys(this.selectedLeagues).join(",");
      const url = `${origin}${path}?s=${this.sportId}&c=${this.category}&l=${league_names}&d=${this.selectedDate.addDayCount}&i=${this.isLive}`;

      window.history.pushState("", "", url);
    },
  },
};
</script>

<style scoped lang="scss">
@import "../../assets/variable.scss";

.float-right {
  position: fixed;
  right: 0.3rem;
  top: 2rem;
  z-index: 9;
  .checkin-btn {
    .a {
      width: 0.74rem;
      cursor: pointer;
    }
    .b {
      width: 0.2rem;
      position: absolute;
      top: -0.1rem;
      right: -0.1rem;
      cursor: pointer;
    }
  }
}

::v-deep .swiper-pagination-bullet {
  background: #fff;
  opacity: 1;
  width: 0.1rem;
  height: 0.1rem;
}
::v-deep .swiper-pagination-bullet-active {
  background: #02a8a2;
  width: 0.36rem;
  border-radius: 0.1rem;
}

.home {
  width: 100%;
  box-sizing: border-box;

  // .banner {
  //   width: 1220px;
  //   display: block;
  //   margin: 0 auto;
  //   margin-bottom: 40px;
  // }

  .video {
    padding-top: 0.86rem;
    padding-bottom: 0.14rem;
    background-position: center;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    display: flex;
    justify-content: center;

    .content {
      width: 14rem;
      margin: 0 auto;
      display: flex;
      height: 6.7rem;
      box-sizing: border-box;
      justify-content: center;
      border-radius: 0.08rem;
      overflow: hidden;
      /* background: #2a2d38; */
      background: linear-gradient(129.36deg, #3d3131 32.85%, #2e1717 98.14%);

      // box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.2);
      border: 0.01rem solid rgba(152, 154, 156, 0.4);
    }

    .player {
      // margin-top: 20px;
      background-color: #000;
      position: relative;
      width: 11.92rem;
      border-radius: 0.08rem;
      overflow: hidden;

      &:hover .join_room_link {
        display: block !important;
      }

      .join_room_link {
        display: none;
        width: 2rem;
        height: 0.56rem;
        padding: 0.05rem;
        cursor: pointer;
        position: absolute;
        z-index: 9;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        border-radius: 0.12rem;
        background: linear-gradient(
          90deg,
          rgba(253, 48, 97, 0.2) 0%,
          rgba(207, 45, 84, 0.2) 100%
        );
      }

      .join_room {
        height: 100%;
        background: linear-gradient(90deg, #fd3061 0%, #cf2d54 100%);
        border-radius: 0.08rem;
        z-index: 3;
        font-size: 0.2rem;
        color: #fff;
      }

      .join_room:hover {
        background-color: #02a8a2;
        color: #fff;
      }
    }

    .video-list {
      padding: 0.08rem 0.11rem;
      box-sizing: border-box;
      flex: 1;
      height: 100%;
      // overflow-y: scroll;
      // overflow-x: hidden;
      display: flex;
      flex-direction: column;
      align-items: flex-end;
      position: relative;
      z-index: 8;

      &::-webkit-scrollbar {
        display: none;
      }

      & > li {
        width: 100%;
        // box-shadow: 2.1px 2.1px 10px 0 rgba(0, 0, 0, 0.2);
        // height: 1.05rem;
        height: 19%;
        position: relative;
        box-sizing: border-box;
        background-repeat: no-repeat;
        background-position: center center;
        background-size: cover;
        cursor: pointer;
        margin-bottom: 0.05rem;
        background-color: rgba(0, 0, 0, 0.2);
        border-radius: 0.05rem;
        // overflow: hidden;
        border: 0.02rem solid transparent;
        display: flex;
        justify-content: center;
        align-items: center;

        &:last-child {
          margin-bottom: 0;
        }

        img {
          border-radius: 0.05rem;
          width: 100%;
          height: 100%;
          // width: 1.89rem;
          // height: 1.05rem;
          object-fit: cover;
        }
        .video-list-mask {
          position: absolute;
          height: 100%;
          width: 100%;
          background: rgba(0, 0, 0, 0.2);
        }

        &.active {
          width: 120%;
          height: 22%;
          position: relative;
          // border-color: #26d99d;
          background-clip: padding-box, border-box;
          background-origin: padding-box, border-box;
          background-image: linear-gradient(to right, #fff, #fff),
            linear-gradient(90deg, #ffd912 0%, #ff9900 50%, #fff500 100%);
          &:after,
          &:before {
            content: "";
            position: absolute;
            width: 0;
            height: 0;
            border: 10px solid transparent;
            border-right-color: rgba(255, 222, 1, 1);
            left: 0;
            transform: translateX(-105%);
          }
          .video-list-mask {
            position: absolute;
            height: 100%;
            width: 100%;
            background: rgba(0, 0, 0, 0);
          }
        }
      }
    }
  }

  .home-center {
    width: 100%;
    padding-top: 0.44rem;
    padding-bottom: 0.44rem;
    // background-image: url("./bottombg.jpg");
    background-color: #ffffff;
    // background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    position: relative;
    // background-color: #f4f5f8;

    .content {
      position: relative;
      width: 14rem;
      margin: 0 auto;
    }

    .match-starting {
      display: flex;
      width: 13.48rem;
      .match-starting-more {
        box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.1);
        background-color: #ffffff;
        margin: 10px 0px 10px 10px;
        cursor: pointer;
        width: 80px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        border-radius: 8px;

        & > div {
          font-size: 14px;
          color: #333333;
          letter-spacing: 0;
          font-weight: 400;
          line-height: 28px;
        }

        img {
          width: 32px;
          height: 32px;
        }
      }
    }

    .news-notice {
      width: 14rem;
      margin: 0.3rem auto;
      display: flex;
      .news-box {
        .up {
          height: 0.6rem;
          display: flex;
          align-items: center;
          font-size: 0.26rem;
          color: #333;
          img {
            width: 0.32rem;
            height: 0.32rem;
            margin-right: 0.1rem;
          }
        }
        .down {
          height: 3.54rem;
        }
      }
      .left {
        width: 6.18rem;
      }
      .mid {
        width: 4.26rem;
        .news-more {
          width: 0.32rem;
          height: 0.32rem;
          position: absolute;
          top: 0;
          right: 0;
        }
        .down {
          position: relative;
          background: #fff;
          border-radius: 0.1rem;
          margin-left: 0.16rem;
          padding: 0.16rem 0.12rem;
          display: flex;
          flex-direction: column;
          font-size: 0.14rem;
          color: #999;
          .down-up {
            flex: 1;
            display: flex;
            flex-direction: column;
            .down-up-title {
              font-weight: bold;
              color: #333;
              display: flex;
              .hot {
                img {
                  width: 0.36rem;
                  height: 0.16rem;
                  margin-right: 0.05rem;
                }
              }
              .down-up-title-content {
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
              }
            }
            .down-up-desc {
              color: #999;
              margin-top: 0.05rem;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }
          }
          .down-down {
            border-top: 1px solid #f0f0f0;
            padding-top: 0.1rem;
            height: 1.57rem;
            display: flex;
            flex-direction: column;
            .down-down-title {
              color: #999;
              line-height: 0.4rem;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }
          }
        }
      }
      .right {
        width: 3.4rem;
        margin-left: 0.16rem;
        .right-down {
          background-color: #fff;
          border-radius: 0.1rem;
        }
        .right-notice {
          height: 2.14rem;
          display: flex;
          flex-direction: column;
          .notice-list {
            display: flex;
            align-items: center;
            padding-left: 0.2rem;
            margin-top: 0.05rem;
            height: 0.25rem;
            font-size: 0.14rem;
            font-weight: 400;
            color: #333;
            text-decoration: none;
            .notice-list-dot {
              width: 0.07rem;
              height: 0.07rem;
              border-radius: 50%;
              background-color: #02a8a2;
              margin-right: 0.1rem;
            }
            .notice-list-title {
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }
            .notice-list-time {
              flex: 1;
              display: flex;
              justify-content: flex-end;
              margin-right: 0.2rem;
              font-size: 0.12rem;
              color: #999;
            }
          }
        }
      }
    }

    .hot-live-home {
      height: 3.65rem;
      padding-top: 20px;
      background-image: url("./bg-home-hotlive.png");
      background-position: center;
      background-repeat: no-repeat;
      background-size: cover;
    }

    .star-list {
      margin-bottom: 0.16rem;

      .start-title-content {
        display: flex;
        justify-content: space-between;
        align-items: center;

        span {
          font-size: 14px;
          color: #999;
        }

        // .title {
        //   margin-right: 22px;
        //   font-size: 24px;
        //   // font-style: italic;
        //   color: #333;
        // }

        .more {
          font-size: 0.14rem;
          color: #999999;
          letter-spacing: 0;
          font-weight: 600px;
          display: flex;
          cursor: pointer;
          border: 1px solid #dbdbdb;
          border-radius: 18px;
          padding: 8px 18px;
          position: relative;
          img {
            margin-left: 0.03rem;
          }
          ::before {
            content: "";
            width: 12px;
            height: 12px;
            border: solid #fff;
            border-width: 0 2px 2px 0;
            transform: translate(-50%, -50%) rotate(-45deg);
            position: absolute;
            left: 50%;
            top: 70%;
          }
        }
      }

      .anchors {
        display: flex;

        & > a {
          display: block;
          width: 85px;
          height: 85px;
          margin-right: 59px;
          background-size: cover;
          background-repeat: no-repeat;
          background-position: center center;
          position: relative;
          border-radius: 50%;

          &:last-child {
            margin-right: 0;
          }

          & > img {
            width: 38px;
            height: 16px;
            position: absolute;
            left: 50%;
            transform: translateX(-50%);
            top: 9px;
          }

          & > p {
            position: absolute;
            bottom: -33px;
            width: 100%;
            text-align: center;
            font-size: 17px;
            color: #000;
          }
        }
      }
    }
  }

  .live-item-title {
    display: flex;
    align-items: center;
    padding: 0.16rem 0;

    img {
      width: 28px;
      height: 28px;
      padding-right: 12px;
    }

    .title-content {
      font-size: 22px;
      color: #333334;
      font-weight: 500;
      margin-right: 30px;
    }

    .matchType {
      height: 38px;
      padding: 0 30px;
      font-size: 12px;
      color: #676767;
      margin-right: 10px;
      cursor: pointer;
      border: 1px solid #f0f0f0;
      border-radius: 100px;
      line-height: 38px;
      text-align: center;
    }

    .matchType:hover {
      border: 1px solid #ff3838;
    }

    .selectedType {
      background: linear-gradient(101.98deg, #ff3838 10.8%, #d02d54 95.33%);
      color: #fff;
    }
  }

  .swiper-button {
    background-repeat: no-repeat;
    background-position: center center;
    background-size: 100% auto;
    width: 0.24rem;
    height: 0.96rem;
    top: 50%;
    transform: translateY(-50%);
    margin: 0px;
    cursor: pointer;
  }

  .swiper-button-prev {
    background-image: url("../../assets/img/home/home_arrows_left.png");
    left: -0.3rem;
    z-index: 0;
  }

  .swiper-button-prev:after {
    display: none;
  }

  .swiper-button-next {
    background-image: url("../../assets/img/home/home_arrows_right.png");
    right: -0.3rem;
  }

  .swiper-button-next:after {
    display: none;
  }

  .swiper-match {
    padding: 10px 0px;
    flex: 1;
  }

  .swiper-activity {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
  }

  .activity-item {
    box-sizing: border-box;
    border-radius: 5px;
    cursor: pointer;
    margin-right: 0.2rem;
  }
  .swiper-activity:nth-child(5) {
    margin-right: 0;
  }

  .activity-item-img {
    width: 2.6rem;
    height: 1.1rem;
    object-fit: cover;
    border-radius: 0.05rem;
    border: 0.02rem solid transparent;

    &:hover {
      border-color: #02a8a2;
    }
  }

  .live-content {
    display: flex;
    justify-content: space-between;
    margin-top: -10px;
  }

  .live-recommends {
    width: 268px;
    height: 190px;
    margin-top: 10px;
    box-shadow: 2.1px 2.1px 10px 0 rgba(0, 0, 0, 0.2);

    &:hover {
      margin-top: 0;
    }

    // background : #36424d;
    // background-image: radial-gradient(circle at 0 0, #616b79, #616b79),
    // radial-gradient(circle at 0 0, #616b79, #616b79),
    // linear-gradient(to top, rgba(2, 52, 62, 0.5), rgba(2, 52, 62, 0)),
    // linear-gradient(to top, #37444f, #3f4d58);
    .live-head {
      height: 47px;
      // box-shadow: 2.1px 2.1px 10px 0 rgba(0, 0, 0, 0.2);
      border-bottom: solid 1px #36424d;
      background: url("./gradient-hear.png") no-repeat;
      display: flex;
      align-items: center;
      justify-content: space-between;
      color: #f4f5f8;
      font-size: 12px;
      width: 100%;
      box-sizing: border-box;
      background-size: cover;

      .live-head-name {
        font-size: 16px;
        font-weight: 600;
        color: #fdd5a1;
        margin-left: 16px;
      }

      .live-head-time {
        font-size: 12px;
        letter-spacing: 0.24px;
        color: #fff;
      }

      .live-head-type {
        margin-right: 10px;
        font-size: 12px;
        letter-spacing: 0.24px;
        color: #fff;
      }
    }

    .live-team {
      width: 100%;
      height: 142px;
      background: url("./gradient-big.png") no-repeat;
      background-size: cover;
      box-sizing: border-box;
      display: flex;
      flex-direction: column;
      box-shadow: 2.1px 2.1px 10px 0 rgba(0, 0, 0, 0.2);

      .live-team-box {
        margin-top: 12px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        color: #fff;

        .team-img {
          margin-left: 14px;

          img {
            width: 40px;
            height: 40px;
            border-radius: 50%;
          }
        }

        .team {
          font-size: 12px;
          letter-spacing: 0.24px;
          color: #fefeff;
        }

        .team-num {
          font-size: 24px;
          font-weight: 600;
          color: #fff;
        }

        .anchor {
          margin-right: 16px;

          img {
            width: 40px;
            height: 40px;
            border-radius: 50%;
          }
        }
      }

      .team-boxTop {
        margin-top: 28px;
      }
    }
  }

  .live-recommend {
    margin-left: 15px;
    width: 268px;
    height: 190px;
    background: url("./recommend.png") center center no-repeat;
    box-sizing: border-box;
    padding-right: 2px;

    // background: #40525e;
    .live-title {
      display: flex;
      justify-content: space-between;
      height: 47px;
      align-items: center;
      border-bottom: 1px solid #36424d;

      .live-fixed {
        width: 95%;
        margin: auto;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .live-left {
          font-size: 16px;
          color: #fdd5a1;
        }

        .live-center {
          font-size: 12px;
          color: #ffffff;
        }
      }
    }

    .match {
      display: flex;
      justify-content: space-between;
      height: 2vw;
      align-items: center;
      padding: 0.3vw;
      margin-top: 1vw;

      img {
        width: 37px;
        height: 37px;
      }

      .match-content {
        font-size: 12px;
        color: #fefeff;
      }

      .match-num {
        font-size: 24px;
        color: #ffffff;
      }
    }
  }

  .live-recommend:first-child {
    margin-left: 0;
  }

  .live-recommend:hover {
    transform: translateY(-4px);
  }

  .live-list {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
  }

  .live-match .live {
    //width: 1.94rem;
    //margin-bottom: 0.2rem;
    //margin-right: 0.2rem;
    transition: all 0.2s;
    margin-bottom: 0.32rem;
  }
  .live-match .live:nth-child(5n) {
    margin-right: 0;
  }

  .start-title-competition {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-bottom: 19px;

    .title_match {
      margin-right: 22px;
      font-size: 24px;
      font-style: italic;
      color: #333;
    }

    .start-button_active {
      width: 70px;
      height: 26px;
      font-size: 14px;
      margin-right: 11px;
      color: #ffffff;
      background-image: linear-gradient(
          90deg,
          #58c0ab 0%,
          #369695 50%,
          #146c7e 100%
        ),
        linear-gradient(#28ba74, #28ba74);
      background-blend-mode: normal, normal;
      border-radius: 3px;
      cursor: pointer;
    }

    .start-button {
      width: 70px;
      height: 26px;
      background-color: #ffffff;
      border-radius: 3px;
      border: solid 1px #9999;
      margin-right: 11px;
      cursor: pointer;
    }

    .start-button:hover {
      border: solid 1px #1c8c7a;
      color: #1c8c7a;
    }
  }

  .live-competition {
    .conduct {
      font-size: 14px;
      font-weight: 600;
      height: 44px;
      background-color: #fff;
      color: #333333;
      display: flex;
      align-items: center;
      justify-content: center;

      span {
        font-size: 30px;
        color: #33be7b;
      }
    }

    .matchsHead {
      box-shadow: inset 0px -1px 0 0 #e0e7f1;
      background-color: #edf1f7;

      .corldsize {
        color: #37444f;
        font-size: 16px;
      }
    }

    .addColor {
      background-color: #fff !important;
    }

    .tr {
      height: 44px;
      display: flex;
      align-items: center;

      // box-shadow: inset 0px -1px 0 0 #5d6674;
      // background-color: #616b79;
      &.head {
        // background: #ffffff;
        & > li {
          // color: #fff;
        }

        .colorbackground {
          font-size: 12px;
          letter-spacing: 0.24px;
          color: #666;
        }
      }

      .hometeam {
        width: 26px;
        height: 18px;
      }

      .live-live {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        margin-right: 101px;

        .iconFontItem {
          font-size: 40px;
          color: #28ba74;
          margin-left: 52px;
        }

        .iconFontItems {
          color: #28ba74;
        }

        .live-button {
          width: 70px;
          height: 26px;
          border-radius: 3px;
          background-image: linear-gradient(to top, #ffa133, #fa8202);
          font-size: 14px;
          font-weight: 600;
          color: #fff;
        }

        .live-avatar {
          width: 26px;
          height: 26px;
          margin: 0 4px;

          img {
            width: 26px;
            height: 26px;
            margin: 0 4px;
            border-radius: 50%;
          }
        }
      }

      .live-Reserve {
        display: flex;
        justify-content: center;
        align-items: center;

        button {
          width: 70px;
          height: 26px;
          border-radius: 3px;
          background-image: linear-gradient(to top, #ffa133, #fa8202);
          font-size: 14px;
          font-weight: 600;
          color: #fff;
          display: flex;
          justify-content: flex-start;
          align-items: center;

          span {
            font-size: 22px;
          }
        }
      }

      .match_score {
        font-size: 20px;
        font-weight: 600;
        color: #37444f;
      }

      & > li {
        position: relative;
        line-height: 44px;
        text-align: center;
        font-size: 16px;
        color: #333333;

        & > i {
          width: 1px;
          height: 20px;
          position: absolute;
          right: 0;
          top: 13px;
          background-color: #dedede;
        }

        &:nth-child(1) {
          width: 160px;

          & > img {
            width: 34px;
            height: 34px;
            border-radius: 50%;
            vertical-align: middle;
          }
        }

        &:nth-child(2) {
          width: 144px;
          text-align: center;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        &:nth-child(3) {
          width: 162px;
        }

        &:nth-child(4) {
          width: 150px;
          display: flex;
          justify-content: flex-end;
          align-items: center;
        }

        &:nth-child(5) {
          width: 130px;

          & > span {
            flex: 1;
            text-align: left;

            &:nth-child(2) {
              flex: none;
              width: 48px;
              text-align: center;
              color: $theme-color;
            }

            &:nth-child(1) {
              text-align: right;
            }
          }
        }

        &:nth-child(6) {
          width: 150px;
          display: flex;
          justify-content: flex-start;
          align-items: center;
        }

        &:nth-child(7) {
          flex: 1;
        }

        &:nth-child(8) {
          flex: 1;

          & > a {
            color: #ffa552;
            cursor: pointer;
            text-decoration: none;
          }
        }

        &:nth-child(9) {
          width: 58px;
        }

        &:nth-child(10) {
          width: 51px;

          & > img {
            width: 22px;
            height: 19px;
            vertical-align: middle;
            cursor: pointer;
          }
        }
      }
    }

    .live-head {
      box-shadow: inset 0px -1px 0 0 #5d6674;
      background-color: #616b79;

      li {
        color: #fff;
      }
    }

    .pagination {
      background-color: #fff;
      padding-top: 10px;
      padding-bottom: 10px;
      display: flex;
      justify-content: center;
    }
  }

  .live-head {
    // background: #616b79 !important;
    li {
      // color: #fff !important;
      font-size: 16px;
    }
  }

  .addColor {
    background-color: #edf1f7 !important;
  }

  .notice-panel {
    border-radius: 16px;
    background: #ffffff;
    padding: 10px 15px;
    margin-top: 10px;
    height: 350px;

    .notice-panel-auto {
      height: 100%;
      overflow-y: auto;
    }

    .notice-item {
      padding: 5px 5px;
      margin: 5px 0px;
      cursor: pointer;

      &:hover {
        background: rgba(0, 0, 0, 0.04);
      }
    }

    .notice-item-dl {
      display: flex;

      dt {
        width: 68px;
        height: 48px;
        // background: rgba(220,178,115,0.10);
        background: url("../../assets/img/home/notice-dt.png") no-repeat;
        background-size: 100% 100%;
        // border: 1px solid rgba(220,178,115,1);
        // border-radius: 8px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        overflow: hidden;

        .t {
          line-height: 16px;
          font-size: 14px;
          color: #333333;
          letter-spacing: 0;
          text-align: center;
          font-weight: 500;
        }

        .b {
          line-height: 15px;
          font-size: 12px;
          color: #666666;
          letter-spacing: 0;
          text-align: center;
          font-weight: 400;
        }
      }

      dd {
        flex: 1;
        overflow: hidden;
        padding: 0px 10px;

        .t {
          line-height: 25px;
          height: 25px;
          display: flex;
          align-items: center;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;

          .a-link {
            display: block;
            font-size: 16px;
            color: #333333;
            letter-spacing: 0;
            font-weight: 600;
          }

          .t-icon {
            margin-left: 5px;
            width: 36px;
            height: 16px;
            background: url("../../assets/img/home/notice-hot.png") no-repeat;
            background-size: 100% 100%;
            font-size: 10px;
            color: #ffffff;
            letter-spacing: 0;
            font-weight: 400;
            display: flex;
            align-items: center;
            justify-content: center;
          }
        }

        .b {
          line-height: 23px;
          height: 23px;
          font-size: 14px;
          color: #666666;
          letter-spacing: 0;
          font-weight: 400;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
    }
  }
}

// 日期切换样式
.match-swiper {
  position: relative;
  background-color: #fff;
  margin: 0.1rem 0rem;
}
.swiper-match-date {
  width: 13rem;
  overflow-x: scroll;
  .date-panel-l {
    position: relative;
    transition: left 0.3s;
  }
}
.swiper-slide {
  width: 1.88rem;
}
.swiper-button {
  background-repeat: no-repeat;
  background-position: center center;
  background-size: 100% auto;
  width: 24px;
  height: 96px;
  top: 50%;
  transform: translateY(-50%);
  margin: 0px;
  cursor: pointer;
}

.swiper-button-prev {
  padding: 0;
  border: 0;
  background: no-repeat center/100% url("./img/arrow_left.png");
  &:after {
    display: none;
  }
}
.swiper-button-next {
  padding: 0;
  border: 0;
  background: no-repeat center/100% url("./img/arrow_right.png");
  z-index: 2;
  &:after {
    display: none;
  }
}

.date-item {
  height: 1rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  color: #666666;
  font-size: 0.16rem;
  img {
    width: 20px;
    height: 20px;
  }
  &.select {
    img {
      width: 40px;
      height: 40px;
    }
  }

  &:hover {
    img {
      width: 40px;
      height: 40px;
    }
  }

  .date-item-t {
    color: #333;
    margin-bottom: 0.08rem;
  }
}

.date-item-t {
  color: #333;
  margin-bottom: 0.08rem;
}

// 时间线
.date-time-line {
  display: flex;
  align-items: center;
}

.date-line {
  background: #e6e6e6;
  width: 102px;
  height: 1px;
}

.hot-live {
  color: #999999;
  font-size: 0.14rem;
  border: 1px solid #dbdbdb;
  border-radius: 18px;
  padding: 8px 18px;
  font-weight: 600px;
}

.hot-live:hover {
  border: 1px solid rgba(227, 50, 74, 1) !important;
  color: rgba(227, 50, 74, 1) !important;
}

.game-btn:hover {
  border: #29f19c;
}

.one {
  position: absolute;
  top: 20px;
  left: 0;
}

.two {
  position: absolute;
  bottom: 20px;
  right: 0;
}

.three {
  position: absolute;
  bottom: 0px;
  left: 0;
}

@media screen and (max-width: 1400px) {
  .live {
    // width: 15% !important;
  }
}

@media screen and (min-width: 1400px) {
  .live {
    // width: 15% !important;
  }
}

/*
@media only screen and (max-width: 1735px) {
  .home .video .content {
    width: 1200px !important;
    height: 576px !important;
  }

  .home .video .video-list {
    width: 176px !important;
  }

  .home .home-center .content {
    width: 1200px !important;
  }

  .home .live-recommends {
    width: 228px !important;
  }

  .home .live-list .live {
    width: 289px !important;
  }
}

@media only screen and (max-width: 1435px) {
  .home .video .content {
    width: 1000px !important;
    height: 480px !important;
    min-width: 1000px;
  }

  .home .video .video-list {
    width: 148px !important;
  }

  .home .home-center .content {
    width: 1000px !important;
  }

  .home .live-recommends {
    width: 188px !important;
  }
}
*/
</style>
